export default class Path {
  public static Home = ''
  public static Language = '/:lang'
  public static Category = '/:wpCategory'
  public static Day = '/:wpDay'
  public static Month = '/:wpMonth'
  public static Post = '/:wpPost'
  public static Tag = '/:wpTag'
  public static Year = '/:wpYear'
}
